import { getAuthToken, isAdmin } from '../util/auth.jsx'
import backend from '../util/backend.jsx';

import classes from './Files.module.css';

const DateFormat = { month: 'long', day: 'numeric', year: 'numeric' };
const TimeFormat = { hour: 'numeric', minute: 'numeric', hour12: true, timeZoneName: 'short' };

async function createStamp(timestamp) {
  let created = new Date(timestamp);
  created.setHours(created.getHours() - (created.getTimezoneOffset() / 60));
  const createDate = created.toLocaleDateString('en-US', DateFormat);

  const createTime = created.toLocaleTimeString('en-US', TimeFormat);
  return `${createDate} @ ${createTime}`;
}

async function downloadFile(id, filename, filetype) {
  const token = getAuthToken();
  const response = await fetch(`https://${backend}/file?id=${id}`, {
    method: 'GET',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  Promise.resolve(response.bytes()).then((result) => {
    const file = new File([new Uint8Array(result)], filename, {type: filetype});
    const file_url = URL.createObjectURL(file);
    const doclink = document.createElement('a');
    doclink.href = file_url;
    doclink.download = filename;
    document.body.appendChild(doclink);
    doclink.click();
    document.body.removeChild(doclink);
    URL.revokeObjectURL(file_url);
  });
}

async function deleteFile(id) {
  const token = getAuthToken();
  const response = await fetch(`https://${backend}/deletefile?id=${id}`, {
    method: 'DELETE',
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  const result = await response;
  window.location.reload();
  return result;
}

function Files({files}) {
  return (
    <div className={classes.files}>
      <h2>Files</h2>
      <table>
        <tr className={classes.file}>
          {isAdmin() &&
            <th>Vendor</th>
          }
          <th>Filename</th>
          <th>Time</th>
          <th> </th>
          <th> </th>
        </tr>
        {files.map((file) => (
          <tr key={file.id} className={classes.file}>
            {isAdmin() &&
              <td>{file.vendor}</td>
            }
            <td>{file.filename}</td>
            <td>{createStamp(file.created)}</td>
            <td><button onClick={() => downloadFile(file.id, file.filename, file.filetype)}>Download</button></td>
            <td><button onClick={() => {if (window.confirm(`Delete ${file.filename}, are you sure?`)) deleteFile(file.id)}}>Delete</button></td>
          </tr>
        ))}
      </table>
    </div>
  );
}

export default Files;
